import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useRef } from 'react';
import useSelections from '@/components/widget/misc/useSelections';
import useSelectionLabels from '@/components/widget/misc/useSelectionLabels';
import redirectUser from '@/utils/redirectUser';
import logger from '@/utils/logger';
import { getEditingAreaAttr, getEditingAreaMetaDataAttr } from '@/components/Editor/hooks/useEditingAreas';
import useSubscribeWidgetResults from '@/components/widget/visualizations/hooks/useSubscribeWidgetResults';
import { hasAnySelectionData } from '@/components/widget/utils/selections';
import { ButtonV2 as Button } from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import ListLoading from './ListLoading';
import Header from '../misc/Header';
import useData from './useData';
import settings, { selectionConfig, labelsSelectionConfig } from './settings';
import StyleVariables, { getSectionAttr, getSectionAttrSelector } from '../../misc/StyleVariables';
import { useReceiptStyles } from './stylesTheme';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29286 6.29289C7.90234 6.68342 7.90234 7.31658 8.29286 7.70711L12.5858 12L8.29286 16.2929C7.90234 16.6834 7.90234 17.3166 8.29286 17.7071C8.68339 18.0976 9.31655 18.0976 9.70708 17.7071L15.4142 12L9.70708 6.29289C9.31655 5.90237 8.68339 5.90237 8.29286 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}; // import DownArrowIcon from '../../../../../../public/icons/arrow-down.svg';

const PREFIX = 'common: components: widget: visualizations: Receipt:';

const ReceiptWidgetVisualSection = _ref => {
  let {
    sectionId,
    widgetId,
    reportingWidgetId,
    elementId,
    editing = false,
    config,
    isMediumContainer,
    isLargeContainer
  } = _ref;
  const isSmallContainer = !isMediumContainer && !isLargeContainer;
  const isLarge = isLargeContainer;
  const callToActionElement = useRef(null);
  const {
    seriesOptions = [],
    globalSeriesOptions,
    ctaButton,
    ctaPrompt,
    ctaPromptImgSrc,
    ctaButtonColor,
    ctaDestination,
    selections = '',
    labelsSelections = '',
    // selectionsStrategy = '',
    selectionsLabeled = false
  } = config;
  const {
    themeStyles
  } = useReceiptStyles(config);
  const results = useSubscribeWidgetResults(reportingWidgetId); // Get relevant results for each selection group

  const {
    selectionResults,
    resultsUpdated
  } = useSelections({
    results,
    selections,
    selectionConfig,
    selectionsLabeled
  });
  const {
    selectionLabels
  } = useSelectionLabels({
    results,
    resultsUpdated,
    labelsSelections,
    labelsSelectionConfig,
    selectionsLabeled,
    labelsTemplate: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.labelsTemplate
  }); // Combine results with rendering styles

  const {
    data
  } = useData(selectionResults, seriesOptions, globalSeriesOptions || {}, selectionLabels); // Data & Loading States

  const hasNoData = !hasAnySelectionData(selectionResults);
  const isLoading = !results.length;
  const hasFooter = Boolean(ctaButton);
  const hasMobileOverview = isSmallContainer && data.length > 1;
  const hasCustomStyles = data.some(_ref2 => {
    let {
      color
    } = _ref2;
    return Boolean(color);
  });
  let ctaButtonStyles = '';

  if (ctaButtonColor && typeof ctaButtonColor === 'string') {
    ctaButtonStyles += `background-color: ${ctaButtonColor} !important; border-color: ${ctaButtonColor} !important;`;
  }

  const handleCtaClick = () => {
    if (!ctaDestination) return;

    try {
      redirectUser(ctaDestination);
    } catch (err) {
      logger.error(Error(`${PREFIX} redirect user CTA click failed: ${err}`)); // TODO report configuration error to content author
    }
  }; // const scrollCtaIntoView = () => {
  //   if (callToActionElement.current) {
  //     callToActionElement.current.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'end',
  //     });
  //   }
  // };


  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: clsx(styles.container, isSmallContainer ? styles['container--small'] : '', isLarge ? styles['container--large'] : '')
  }, getSectionAttr(widgetId, sectionId)), {}, {
    children: [/*#__PURE__*/_jsx(Header, {
      editing: editing,
      widgetId: widgetId,
      sectionId: sectionId,
      config: config,
      className: styles.header
    }), hasCustomStyles && /*#__PURE__*/_jsx("style", {
      type: "text/css",
      children: data.filter(_ref3 => {
        let {
          color
        } = _ref3;
        return Boolean(color);
      }).map(item => {
        const index = data.indexOf(item);
        const itemId = `${widgetId}-${sectionId}-${index}`;
        const itemStyles = `color: ${item.color} !important;`;
        return `.${styles.item}[data-item-id="${itemId}"] > .${styles.label} {${itemStyles}}`;
      })
    }), isLoading || hasNoData ? /*#__PURE__*/_jsx(ListLoading, {
      editing: editing
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: data.length ? /*#__PURE__*/_jsx("ul", {
        className: styles.list,
        children: data.map((_ref4, index) => {
          let {
            label,
            separator,
            value,
            indented,
            selection,
            selectionIndex,
            tooltip: itemTooltip
          } = _ref4;
          const isLast = index !== 0 && data.length - 1 === index;
          const isSeparated = (separator || themeStyles.listItemDividerStyle === 'solid') && !isLast;
          const itemId = `${widgetId}-${sectionId}-${index}`;
          return /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread(_objectSpread({
            className: clsx(styles.item, isSeparated ? styles['item--separated'] : '', indented && !isLast ? styles['item--sub'] : '', isLast ? styles['item--last'] : ''),
            "data-item-id": itemId
          }, editing && selectionIndex > -1 && {
            [getEditingAreaAttr()]: `item-${selectionIndex}`
          }), editing && {
            [getEditingAreaMetaDataAttr()]: JSON.stringify({
              selection,
              selectionIndex
            })
          }), {}, {
            children: [/*#__PURE__*/_jsx("span", {
              className: clsx(styles.item__name, styles.label, isLast ? styles['label--lastLabel'] : ''),
              dangerouslySetInnerHTML: {
                __html: label
              }
            }), !isLast && themeStyles.listItemDividerStyle === 'underline' && /*#__PURE__*/_jsx("span", {
              className: styles.item__underline
            }), /*#__PURE__*/_jsxs("span", {
              className: clsx(styles.item__value, styles.label, isLast ? styles['label--lastValue'] : ''),
              children: [/*#__PURE__*/_jsx("span", {
                dangerouslySetInnerHTML: {
                  __html: value
                }
              }), itemTooltip && /*#__PURE__*/_jsx(Tooltip, {
                placement: "left",
                className: styles.item__icon,
                content: itemTooltip,
                children: /*#__PURE__*/_jsx(InfoIcon, {})
              })]
            })]
          }), itemId);
        })
      }) : null
    }), hasFooter ? /*#__PURE__*/_jsxs("footer", {
      ref: callToActionElement,
      className: clsx(styles.footer, hasMobileOverview ? styles['footer--mobileOverview'] : ''),
      children: [ctaButtonColor ? /*#__PURE__*/_jsx("style", {
        type: "text/css",
        children: `.${styles.footer__action},${styles.footer__action}:hover {${ctaButtonStyles}}`
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Button, {
        size: "large",
        variant: "primary",
        className: styles.footer__action,
        rightIcon: /*#__PURE__*/_jsx(ArrowRightIcon, {}),
        onClick: handleCtaClick,
        children: ctaButton
      }), ctaPrompt || ctaPromptImgSrc ? /*#__PURE__*/_jsxs("div", {
        className: styles.footer__prompt,
        children: [ctaPromptImgSrc && /*#__PURE__*/_jsx("img", {
          className: styles.footer__promptImg,
          src: ctaPromptImgSrc
        }), ctaPrompt && /*#__PURE__*/_jsx("span", {
          className: styles.label,
          children: ctaPrompt
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, sectionId),
      data: _objectSpread(_objectSpread({}, settings.styles), config.styles || {})
    })]
  }));
};

export default ReceiptWidgetVisualSection;
export { settings, selectionConfig, labelsSelectionConfig };